import { render } from "./FormularioOperadorPagamento.vue?vue&type=template&id=6752c60a&scoped=true"
import script from "./FormularioOperadorPagamento.vue?vue&type=script&lang=js"
export * from "./FormularioOperadorPagamento.vue?vue&type=script&lang=js"

import "./FormularioOperadorPagamento.vue?vue&type=style&index=0&id=6752c60a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6752c60a"]])

export default __exports__